import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    siteKey: String
  }

  connect() {
    this.scriptPromise = null
  }

  warmup() {
    if (!this.siteKeyValue) return
    this.ensureScriptLoaded()
  }

  async submit(event) {
    if (!this.siteKeyValue) return

    event.preventDefault()

    try {
      await this.ensureScriptLoaded()
    } catch (_) {
      this.element.submit()
      return
    }

    if (!window.grecaptcha) {
      this.element.submit()
      return
    }

    const enterprise = grecaptcha.enterprise && grecaptcha.enterprise.execute
    const ready = enterprise ? grecaptcha.enterprise.ready : grecaptcha.ready
    const execute = enterprise ? grecaptcha.enterprise.execute : grecaptcha.execute

    ready(() => {
      execute(this.siteKeyValue, { action: "contact" })
        .then((token) => {
          const tokenInput = document.getElementById("recaptcha_token")
          if (tokenInput) tokenInput.value = token
          this.element.submit()
        })
        .catch(() => {
          this.element.submit()
        })
    })
  }

  ensureScriptLoaded() {
    if (window.grecaptcha) return Promise.resolve()
    if (this.scriptPromise) return this.scriptPromise

    this.scriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector("script[data-recaptcha-loader='contact']")
      if (existing) {
        existing.addEventListener("load", () => resolve(), { once: true })
        existing.addEventListener("error", () => reject(new Error("recaptcha load failed")), { once: true })
        return
      }

      const script = document.createElement("script")
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(this.siteKeyValue)}`
      script.async = true
      script.defer = true
      script.dataset.recaptchaLoader = "contact"
      script.onload = () => resolve()
      script.onerror = () => reject(new Error("recaptcha load failed"))
      document.head.appendChild(script)
    })

    return this.scriptPromise
  }
}
